import React from 'react';

const Dropdown = ({ color = 'black', className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6364 14.371H2.51515C2.34779 14.371 2.21212 14.2338 2.21212 14.0645V11C2.21212 10.8308 2.34779 10.6935 2.51515 10.6935H14.6364C14.8037 10.6935 14.9394 10.8308 14.9394 11V14.0645C14.9394 14.2338 14.8037 14.371 14.6364 14.371ZM14.3333 11.3065H2.81818V13.7581H14.3333V11.3065ZM19.4851 1.5C20.3216 1.5 21 2.18632 21 3.03202V6.70991C21 7.55584 20.3213 8.24194 19.4851 8.24194H2.5157C1.67882 8.24194 1 7.55566 1 6.70991V3.03202C1 2.186 1.67894 1.5 2.5157 1.5H19.4851ZM2.5157 2.1129C2.01354 2.1129 1.60606 2.52462 1.60606 3.03202V6.70991C1.60606 7.21712 2.0135 7.62903 2.5157 7.62903H14.3333V2.1129H2.5157ZM14.9394 2.1129V7.62903H19.4851C19.9867 7.62903 20.3939 7.2173 20.3939 6.70991V3.03202C20.3939 2.52478 19.9868 2.1129 19.4851 2.1129H14.9394ZM18.3615 5.39411L17.6667 4.69145L16.9718 5.39411C16.8535 5.51379 16.6616 5.51379 16.5433 5.39411C16.425 5.27444 16.425 5.0804 16.5433 4.96073L17.4524 4.04137C17.5707 3.92169 17.7626 3.92169 17.8809 4.04137L18.79 4.96073C18.9084 5.0804 18.9084 5.27444 18.79 5.39411C18.6717 5.51379 18.4798 5.51379 18.3615 5.39411ZM3.72727 5.17742C3.55991 5.17742 3.42424 5.04022 3.42424 4.87097C3.42424 4.70172 3.55991 4.56452 3.72727 4.56452H9.1887C9.35606 4.56452 9.49173 4.70172 9.49173 4.87097C9.49173 5.04022 9.35606 5.17742 9.1887 5.17742H3.72727Z"
        fill={color}
        stroke={color}
        strokeWidth="0.7"
      />
    </svg>
  );
};

export default Dropdown;
